module.exports = __webpack_public_path__ + "img/_DSC6788.6f4a0b9a.jpg";